import { App } from 'vue'
import View from './ListView.vue'
import ViewSearch from './ListViewSearch.vue'

const register = (app: App<Element>): void => {
  app
    .component('list-view', View)
    .component('list-view-search', ViewSearch)
}

export default {
  register,
}
